import { render, staticRenderFns } from "./LogoProperty.vue?vue&type=template&id=a901494e&"
import script from "./LogoProperty.vue?vue&type=script&lang=js&"
export * from "./LogoProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports